import React from 'react'
export default '_self' in React.createElement('div')